export const queryKeys = {
  config: 'config' as const,
  fetchFilters: {
    all: 'fetchFilters' as const,
    options: (filterType: string) => [queryKeys.fetchFilters.all, filterType] as const,
  },
  fetchProfile: 'fetchProfile' as const,
  searchSuggest: {
    all: 'searchSuggest' as const,
    allByTerm: (term: string) => [queryKeys.searchSuggest.all, term] as const,
  },
  fetchContentTypePermissions: 'fetchContentTypePermissions' as const,
  recentSearches: {
    all: 'fetchRecentSearches',
  },
  savedSearches: {
    all: 'fetchSavedSearches',
  },
  firstLogin: {
    all: 'firstLogin' as const,
    byPath: (enabled: boolean) => [queryKeys.firstLogin.all, enabled] as const,
  },
  translationConsent: {
    content: 'translationConsentContent',
    consent: 'translationConsent',
    userAcknowledge: 'translationConsentUserAcknowledge',
  },
  userTranslationConsent: 'userTranslationConsent' as const,
};
